import './src/index.css';
import React from 'react';
import Page from './src/components/Page';
import Providers from './src/components/Providers';

export const wrapRootElement = ({ element }) => {
  return <Providers>{element}</Providers>;
};

export const wrapPageElement = ({ element, props }) => {
  return <Page {...props}>{element}</Page>;
};
